import React, { useState, useEffect } from "react";
import { Table, Spin, Button } from "antd";
import Modal from "react-modal";
import AddCalssResult from "../../modals/teacher/AddCalssResult";
import { getRequest } from "../../services";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    border: "none",
  },
};


const ClassTestGradeTable = (props) => {

  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const { state } = props;
  const [classTestData, setClassTestData] = useState([]);
  const [totalMarks, setTotalMarks] = useState(null);
  const [studentMap, setStudentMap] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Fetch marks
        const marksRes = await getRequest(`/api/Grades/get-offline-exam-marks?subjectId=${state.subjectId}`);
        const marksData = marksRes.data;
        setTotalMarks(marksData.totalMarks);
        // Fetch students
        const studentsRes = await getRequest(`/api/ClassAssignment/GetStudentsInClass?classSectionId=${state.sectionId}&subjectId=${state.subjectId}`);
        const studentsArr = studentsRes.data?.students || [];
        // Build map for fast lookup
        const map = {};
        studentsArr.forEach(s => { map[s.id] = s.name; });
        setStudentMap(map);
        // Map marks to table data with names
        const mapped = (marksData.studentDetails || []).map((item, idx) => ({
          key: item.studentId || idx,
          studentName: map[item.studentId] || item.studentId,
          obtainedMarks: item.obtainedMarks,
          attendanceStatus: item.attendanceStatus,
          remarks: item.remarks,
        }));
        setClassTestData(mapped);
      } catch (error) {
        setClassTestData([]);
      } finally {
        setLoading(false);
      }
    };
    if (state?.subjectId && state?.sectionId) fetchData();
  }, [state?.subjectId, state?.sectionId]);

  const columns = [
    {
      title: 'Student Name',
      dataIndex: 'studentName',
      key: 'studentName',
    },
    {
      title: 'Obtained Marks',
      dataIndex: 'obtainedMarks',
      key: 'obtainedMarks',
    },
    {
      title: 'Total Marks',
      dataIndex: 'totalMarks',
      key: 'totalMarks',
      render: () => totalMarks,
    },
    {
      title: 'Attendance Status',
      dataIndex: 'attendanceStatus',
      key: 'attendanceStatus',
    },
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      key: 'remarks',
    },
  ];

  const handleAddMark = () => {
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  return (
    <div>
      <p className="text-end">
      <Button type="primary" onClick={handleAddMark} style={{ marginBottom: 16 }}>
        Add Mark
      </Button>
      </p>
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={classTestData}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: classTestData.length,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50],
            onChange: (page, size) => {
              setCurrentPage(page);
              setPageSize(size);
            },
          }}
          bordered
          scroll={{ x: 'max-content' }}
          className="responsive-table"
          size="small"
        />
      </Spin>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <AddCalssResult
          onRequestClose={closeModal}
          state={state}
        />
      </Modal>
    </div>
  );
};

export default ClassTestGradeTable;